<style src="css/result.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="测试结果"></topbar>
        <div class="mainBox">
            <div class="box">
                <div class="topBox">
                    <div class="userBox">
                        <div class="userImg"></div>
                        <div>
                            <div class="userName">{{scaleResult.nickName}}</div>
                            <div class="time">{{scaleResult.createTime | time}}</div>
                        </div>

                    </div>

                </div>
                <div class="testTitle">{{scaleResult.scaleTitle}}</div>
<!--                <div class="pic"></div>-->
                <div class="level" v-if="scaleResult.scaleInfoResult">{{scaleResult.scaleInfoResult.level}}</div>
                <div class="content" v-if="scaleResult.scaleInfoResult" v-html="scaleResult.scaleInfoResult.content"></div>
            </div>

          <div class="contentBox" v-if="resultType===1">
            <div class="r2"></div>
            <ul class="synthetical">
              <li style="color: #606060;border-bottom: solid 0.02rem #707070">
                <span>综合项</span>
                <span>常模（均分±标准差)</span>
              </li>
              <li v-for="item in scaleResultRoots.slice(0,5)">
                <span class="symptom">{{item.symptom}}</span>
                <span>{{item.resultScore}}</span>
                <span class="explains">{{item.explains}}</span>
              </li>
              <li style="color: #606060;border-bottom: solid 0.02rem #707070;margin-top: .8rem">
                <span class="symptom">因子项</span>
                <span style="width: .5rem">得分</span>
                <span style="width: .5rem">均分</span>
                <span style="width: 1rem">诊断参考</span>
              </li>
              <li v-for="item in scaleResultRoots.slice(5,scaleResultRoots.length)">
                <span class="symptom">{{item.symptom}}</span>
                <span style="width: .5rem">{{item.resultScore}}</span>
                <span style="width: .5rem">{{(item.resultScore/item.questionCount).toFixed(2)}}</span>
                <span style="width: 1rem" class="checkState" :class="{active:item.checkState==='无症状'}">{{item.checkState}}</span>
              </li>

            </ul>
          </div>
          <div class="contentBox" v-if="resultType===1">
            <div class="r3"></div>
            <ul class="explainBox">
              <li class="explainItem" v-for="item in scaleResultRoots.slice(5,scaleResultRoots.length)">
                <span>【{{item.symptom}}】：</span>
                {{item.explains}}
              </li>
            </ul>
          </div>
          <div class="contentBox" v-if="resultType===2">
            <div class="r2"></div>
            <ul class="synthetical">
              <li style="color: #606060;border-bottom: solid 0.02rem #707070;margin-top: .8rem">
                <span class="symptom">因子项</span>
                <span style="width: .5rem">得分</span>
                <span style="width: 3rem;text-align: right">诊断参考</span>
              </li>
              <li v-for="item in scaleResultRoots">
                <span class="symptom">{{item.symptom}}</span>
                <span style="width: .5rem">{{item.resultScore}}</span>
                <span style="width: 3rem;text-align: right">{{item.remark}}</span>
              </li>
            </ul>
          </div>
          <div class="contentBox" v-if="resultType===2">
            <div class="r3"></div>
            <ul class="explainBox">
              <li class="explainItem" v-for="item in scaleResultRoots">
                <span>【{{item.symptom}}】：</span>
                {{item.explains}}
              </li>
            </ul>
          </div>
<!--            <div class="recommendBox">-->
<!--                <div class="recommendLeft">-->
<!--                    <div class="recommendTitle">心理测试</div>-->
<!--                    <div class="recommendContent">这里有最有趣的测试</div>-->
<!--                    <div class="recommendActive">快来测一测吧</div>-->
<!--                </div>-->
<!--                <div class="recommendRight"></div>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import Vue from "vue"

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                scaleResult:{},
                scaleInfoResult: '',
                scaleUserTestRecord: '',
                scaleResultRoots: '',
                createTime: '',
                nickName: '',
                scaleTitle: '',
                resultType: '',
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async getScaleInfo() {
                let obj = {}
                obj.testId = this.$route.query.testId;
                let data = await getSources("/bear-scale/api/scaleInfoQuestion/getScaleResult.json", obj);
                if (data.status === 0) {
                    this.scaleResult=data.scaleResult
                    this.scaleUserTestRecord = data.scaleResult.scaleUserTestRecord;
                    this.scaleInfoResult = data.scaleResult.scaleInfoResult;
                    this.scaleResultRoots = data.scaleResult.scaleResultRoots;
                    this.createTime = data.scaleResult.createTime;
                    this.nickName = data.scaleResult.nickName;
                    this.scaleTitle = data.scaleResult.scaleTitle;
                    this.resultType = data.scaleResult.resultType;
                    if(this.scaleResultRoots){
                        this.scaleResultRoots.forEach((item)=>{
                            if(item.resultScore/item.questionCount===1){
                                Vue.set(item, "checkState", '无症状');
                            }else if(item.resultScore/item.questionCount>1&&item.resultScore/item.questionCount<=2){
                                Vue.set(item, "checkState", '很轻');
                            }else if(item.resultScore/item.questionCount>2&&item.resultScore/item.questionCount<=3){
                                Vue.set(item, "checkState", '中等');
                            }else if(item.resultScore/item.questionCount>3&&item.resultScore/item.questionCount<=4){
                                Vue.set(item, "checkState", '偏重');
                            }else if(item.resultScore/item.questionCount>4&&item.resultScore/item.questionCount<=5){
                                Vue.set(item, "checkState", '严重');
                            }
                        })
                    }

                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
            this.getScaleInfo()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/result.vue?7924dc3a